<template>
    <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
        <ion-card v-if="show" mode="ios" style="margin: 0 0 10px 0px">
            <ion-item>
                <ion-label mode="md" class="ion-text-wrap">
                    <h3>{{ question }}</h3>
                </ion-label>
            </ion-item>
            <ion-card-content>
                <div v-html="answer"></div>
            </ion-card-content>
        </ion-card>
    </slide-x-left-transition>
</template>

<script>
    export default {
        name: 'ItemHelp',
        props: ['index', 'slug', 'question', 'answer'],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        }
    }
</script>

<style lang="scss" scoped>
    ion-card-content{
        padding: 12px 15px 15px;
    }
</style>